<template>
    <div class="child-page">
        <segment-tab class="segment" :data="navList" :titleKey="'name'" :pickIndex="navIndex" @changed="navTabChanged"></segment-tab>
        <div class="container">
            <!-- 会员订单 -->
            <order-list v-if="navIndex == 0" :type="0" key="vip_order"></order-list>
            <!-- 共享订单、游戏订单 -->
            <order-list v-if="navIndex == 1" :type="1" key="game_order"></order-list>
            <!-- 独享订单、账号订单 -->
            <order-list v-if="navIndex == 2" :type="2" key="account_order"></order-list>
        </div>
    </div>
</template>
<script>
import segmentTab from '@/components/Segments/segment-tab.vue'
import OrderList from './OrderList.vue'

export default {
    name: 'MyOrder',
    components: {
        segmentTab,
        OrderList
    },
    data() {
        return {
            navList: [
                { id: 0, name: '会员订单' },
                { id: 1, name: '盒子账号' },
                { id: 2, name: '商品订单' }
            ],
            navIndex: 0
        }
    },
    methods: {
        navTabChanged(index) {
            this.navIndex = index
        }
    }
}
</script>
<style lang="less" scoped>
.child-page {
    width: 100%;
    height: 100%;

    .segment {
        margin-left: 30px;
    }

    .container {
        margin-top: 30px;
        width: 100%;
        height: calc(100% - 70px);
        background-color: @bg-color-1E;
        border-radius: 10px;
    }
}
</style>
